<template>
	<v-app>
		<NavBar />
		<v-main class="ma-4">
			<h1>Airplanes</h1>
			<v-dialog v-model="dialog">
				<template #activator="{ props }">
					<v-btn color="primary" v-bind="props"> New Airplane </v-btn>
				</template>
				<v-card>
					<v-card-text>
						<PlaneInput @closeOverlay="dialog = false" />
					</v-card-text>
				</v-card>
			</v-dialog>
			<div class="d-flex flex-wrap">
				<PlaneCard
					@click="$router.push('/planes/' + plane._id)"
					v-for="plane in planes"
					:registration="plane.callsign"
					:type="plane.type.Model"
					:_id="plane._id"
				/>
			</div>
		</v-main>
	</v-app>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import NavBar from "@/components/NavBar";
import PlaneInput from "@/components/PlaneInput";
import PlaneCard from "@/components/PlaneCard";
export default {
	computed: {
		...mapState({
			token: "token",
		}),
	},
	data: () => ({
		dialog: false,
		planes: null,
	}),
	components: {
		NavBar,
		PlaneInput,
		PlaneCard,
	},

	mounted() {
		axios
			.get(process.env.VUE_APP_BACKEND_URL + "/plane", {
				headers: {
					Authorization: "bearer " + this.token,
				},
			})
			.then((response) => {
				this.planes = response.data;
				console.log(this.planes);
			})
			.catch((e) => {
				console.error(e);
			});
	},
};
</script>

<style></style>
